<template>
  <div class="section">
    <el-row class="section-title">
      <el-col :span="12">使用优惠卡券</el-col>
    </el-row>
    <!-- <div v-if="!isUseCoupon || !isUseSclCoupon || !isUseXnCoupon" class="extra"> -->
    <div v-if="!isUseCoupon" class="extra">
      <div v-if="!isUseCoupon">含有冰萃品牌的商品不能使用优惠卡券</div>
      <!-- <div v-if="!isUseSclCoupon" style="margin-top: 4px;">生产力物料分类商品和其他商品同时下单，不能使用优惠卡券</div> -->
      <!-- <div v-if="!isUseXnCoupon" style="margin-top: 4px;">含有活动专区的商品不能使用优惠卡券</div> -->
      <!-- <div v-if="!isUseCoupon" style="margin-top: 4px;">非冰柜商品不能使用优惠卡券</div> -->
    </div>
    <div v-else>
      <div v-if="!couponList.length" class="extra">无可用卡券</div>
      <div v-else class="section-content">
        <div>
          <div v-if="!(couponActivityInfo.couponCode && sumPrice >= 20000)" class="coupon-line">
            <!-- <el-input v-model="inputCouponCode" size="small" class="coupon-code" placeholder="输入卡券编号"/>
            <el-input v-model="inputGiftCode" size="small" class="gift-code" placeholder="输入卡券密码"/>
            <el-button class="btn-yellow" size="small" @click="getCoupon">使用卡券</el-button>-->
            <span class="used-code">
              已使用优惠卡券：
              <span v-if="couponData.couponCode">{{ couponData.couponCode }}</span>
            </span>
            <el-button v-if="couponData.couponCode" type="text" size="small" @click="removeCouponCode()">清除</el-button>
          </div>
          <!-- <div v-if="showTips" class="coupon-tip">
            <span v-if="tipsText">{{ tipsText }}</span>
            <span v-else>注意：优惠卡券仅限一次性使用，若您输入优惠码可抵扣金额大于订单金额，也无法再次抵扣。</span>
          </div>-->
        </div>
        <el-row class="coupon-card">
          <el-col :span="23">
            <div>
              <div v-for="(item, index) in filterCouponList" :key="index" class="coupon-card-item" @click="testCoupon(item)">
                <el-card v-if="item.couponType === '01'">
                  <el-row slot="header">
                    <el-col :span="24">
                      <div class="ellipsis">{{ item.couponName }}</div>
                    </el-col>
                    <el-col :span="24">
                      <el-row>
                        <el-col :span="6">
                          <div class="extra">兑换商品</div>
                        </el-col>
                        <el-col :span="18" class="text-right item_code">商品编码：{{ item.limitItemCode }}</el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row class="add_info">
                    <el-col :span="12">
                      失效期：
                      <span v-if="item.expireDate">{{ item.expireDate | parseTime('{y}-{m}-{d}') }}</span>
                      <span v-else>无</span>
                    </el-col>
                    <el-col :span="12" class="text-right amount_info">数量：{{ item.limitItemQty | toThousandslsFilter }}</el-col>
                  </el-row>
                  <div v-show="checkedCouponCode === item.couponCode" class="triangle">
                    <i class="el-icon-check" />
                  </div>
                </el-card>
                <el-card v-if="item.couponType === '02'">
                  <el-row slot="header">
                    <el-col :span="24">
                      <div class="ellipsis">{{ item.couponName }}</div>
                    </el-col>
                    <el-col :span="24">
                      <el-row>
                        <el-col :span="12">
                          <div class="extra">订单满减</div>
                        </el-col>
                        <el-col :span="12" class="text-right">
                          <span class="amount">
                            <span class="symbol">￥</span>
                            {{ item.deductAmountValue | toThousandslsFilter }}
                          </span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row class="add_info">
                    <el-col :span="12">
                      失效期：
                      <span v-if="item.expireDate">{{ item.expireDate | parseTime('{y}-{m}-{d}') }}</span>
                      <span v-else>无</span>
                    </el-col>
                    <el-col :span="12" class="text-right amount_info">满{{ item.deductAmountLimit | toThousandslsFilter }}可用</el-col>
                  </el-row>
                  <div v-show="checkedCouponCode === item.couponCode" class="triangle">
                    <i class="el-icon-check" />
                  </div>
                </el-card>
                <el-card v-if="item.couponType === '03'">
                  <el-row slot="header">
                    <el-col :span="24">
                      <div class="ellipsis">{{ item.couponName }}</div>
                    </el-col>
                    <el-col :span="24">
                      <el-row>
                        <el-col :span="12">
                          <div class="extra">商品折扣</div>
                        </el-col>
                        <el-col :span="12" class="text-right">
                          <span class="amount">{{ percentage(item.discountRatio) }}</span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row class="add_info">
                    <el-col :span="12">
                      失效期：
                      <span v-if="item.expireDate">{{ item.expireDate | parseTime('{y}-{m}-{d}') }}</span>
                      <span v-else>无</span>
                    </el-col>
                    <el-col :span="12" class="text-right">可用券数：{{ item.remainTime }}</el-col>
                  </el-row>
                  <div v-show="checkedCouponCode === item.couponCode" class="triangle">
                    <i class="el-icon-check" />
                  </div>
                </el-card>
                <el-card v-if="item.couponType === '04'">
                  <el-row slot="header">
                    <el-col :span="24">
                      <div class="ellipsis">{{ item.couponName }}</div>
                    </el-col>
                    <el-col :span="24">
                      <el-row>
                        <el-col :span="12">
                          <div class="extra">抵扣金额</div>
                        </el-col>
                        <el-col :span="12" class="text-right">
                          <span class="amount">
                            <span class="symbol">￥</span>
                            {{ item.discountAmount | toThousandslsFilter }}
                          </span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row class="add_info">
                    <el-col :span="16">
                      失效期：
                      <span v-if="item.expireDate">{{ item.expireDate | parseTime('{y}-{m}-{d}') }}</span>
                      <span v-else>无</span>
                    </el-col>
                  </el-row>
                  <div v-show="checkedCouponCode === item.couponCode" class="triangle">
                    <i class="el-icon-check" />
                  </div>
                </el-card>
                <el-card v-if="item.couponType === '05'">
                  <el-row slot="header">
                    <el-col :span="24">
                      <div class="ellipsis">{{ item.couponName }}</div>
                    </el-col>
                    <el-col :span="24">
                      <el-row>
                        <el-col :span="12">
                          <div class="extra">叠加满减</div>
                        </el-col>
                        <el-col :span="12" class="text-right">
                          <span class="amount">
                            <span class="symbol">￥</span>
                            {{ item.deductAmountValue | toThousandslsFilter }}
                          </span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row class="add_info">
                    <el-col :span="12">
                      <div>可用券数：{{ item.remainTime }}</div>
                      <div class="limit_qty">
                        失效期：
                        <span v-if="item.expireDate">{{ item.expireDate | parseTime('{y}-{m}-{d}') }}</span>
                        <span v-else>无</span>
                      </div>
                    </el-col>
                    <el-col
                      :span="12"
                      class="text-right amount_info"
                    >每满{{ item.deductAmountLimit | toThousandslsFilter }}减{{ item.deductAmountValue | toThousandslsFilter }}</el-col>
                  </el-row>
                  <div v-show="checkedCouponCode === item.couponCode" class="triangle">
                    <i class="el-icon-check" />
                  </div>
                </el-card>
              </div>
            </div>
          </el-col>
          <el-col v-if="isMore" :span="1" class="more-coupon">
            <span v-if="!isShow" @click="moreCoupon">更多</span>
            <span v-else @click="moreCoupon">隐藏</span>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
const math = require("mathjs")
import orderApi from '@/api/order'
import { commonUtils } from '@/utils/common'
export default {
  name: 'OrderConfirmCoupon',
  props: {
    itemList: {
      type: Array,
      default: () => []
    },
    totalAmount: {
      type: Number,
      default: 0
    },
    showTips: {
      type: Boolean,
      default: true
    },
    tipsText: {
      type: String,
      default: ''
    },
    ecardNumber: {
      type: String,
      default: ''
    },
    isUseCoupon: {
      type: Boolean,
      default: true
    },
    isUseSclCoupon: {
      type: Boolean,
      default: true
    },
    isUseXnCoupon: {
      type: Boolean,
      default: true
    },
    isShowSclCoupon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // inputCouponCode: '',
      // inputGiftCode: '',
      couponData: {
        couponCode: '',
        giftCode: '',
        couponAmount: 0
      },
      couponList: [],
      filterCouponList: [],
      checkedCouponCode: '',
      limitNum: 4,
      isMore: false,
      isShow: false,
      isFirst: true,
      applicableItemList: [],
      couponActivityInfo: {},
      sumPrice: 0
    }
  },
  watch: {
    itemList: {
      immediate: true,
      handler (val) {
        if (val.length) {
          if (this.isFirst) {
            this.queryAllCoupon()
            this.isFirst = false
          }
        }
      }
    }

  },
  methods: {
    queryAllCoupon () {
      const itemIds = []
      for (const i in this.itemList) {
        itemIds.push(this.itemList[i].itemId)
        this.sumPrice += this.itemList[i].itemPrice * this.itemList[i].itemQty
      }

      orderApi.queryAllCoupon({ itemIds: itemIds.join(',') }).then(response => {
        if (response.data.resultCode === '0') {
          const couponList = response.data.resultData.couponList || []
          this.couponActivityInfo = response.data.resultData.couponActivityInfo || {}
          let arr = []
          for (let i = 0; i < couponList.length; i++) {
            if (couponList[i].couponCode.indexOf('SCL') > -1) {
              arr.push(couponList.splice(i, 1)[0])
              i--
            }
          }
          if (this.isShowSclCoupon) {
            // 全部是生产力物料商品 -> 只留下生产力物料的卡券
            this.couponList = arr
          } else {
            // 非生产力物料商品 -> 去掉生产力物料的卡券
            this.couponList = couponList
          }

          // 2022活动优惠券存在,并且商品金额大于20000
          if (this.couponActivityInfo.couponCode && this.sumPrice >= 20000) {
            if (!this.isUseCoupon) {
              this.couponList = []
            }
            // 冰萃商品可见优惠券
            this.$emit('setUseCoupon', true)
            this.couponList.unshift(this.couponActivityInfo)
            this.checkedCouponCode = this.couponActivityInfo.couponCode
            this.couponData.couponCode = this.couponActivityInfo.couponCode
            this.couponData.giftCode = this.couponActivityInfo.giftCode
            this.couponData.couponAmount = this.couponActivityInfo.deductAmountValue
            this.$emit('couponChanged', this.couponData)
          }


          for (let i = 0; i < this.couponList.length; i++) {
            if (this.couponList[i].couponType === '05' || this.couponList[i].couponType === '03') {
              this.couponList[i].remainTime = math.subtract(this.couponList[i].limitDiscountQty, this.couponList[i].usedDiscountQty)
            }
          }

          if (this.couponList.length > this.limitNum) {
            this.isMore = true
            this.filterCouponList = this.couponList.slice(0, this.limitNum)
          } else {
            this.filterCouponList = this.couponList
          }
        } else {
          this.$alert(response.data.resultMsg, '系统提示')
        }
      })
    },
    // getCoupon() {
    //   if (!this.inputCouponCode) {
    //     this.$alert('请输入卡券编号', '系统提示')
    //     return
    //   }
    //   if (!this.inputGiftCode) {
    //     this.$alert('请输入卡券密码', '系统提示')
    //     return
    //   }
    //   this.queryCoupon({ couponCode: this.inputCouponCode, giftCode: this.inputGiftCode })
    // },
    testCoupon (item) {
      if (this.couponActivityInfo.couponCode && this.sumPrice >= 20000) {
        return
      }
      // 未使用多利e卡
      if (!this.ecardNumber) {
        if (this.checkedCouponCode === item.couponCode) {
          this.removeCouponCode()
          return
        }
        this.checkedCouponCode = item.couponCode
        this.queryCoupon(item)
        return
      }
      this.$confirm('是否取消使用多利e卡', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        confirmButtonClass: 'btn-red',
        type: 'info'
      }).then(() => {
        // 取消多利e卡
        this.checkedCouponCode = item.couponCode
        this.queryCoupon(item)
      }).catch(() => {
        console.log('cancel opt')
      })
    },
    queryCoupon (item) {
      this.clearReduce()
      const params = { couponCode: item.couponCode, giftCode: item.giftCode }
      orderApi.queryCoupon(params).then(response => {
        if (response.data.resultCode === '0') {
          // this.$alert('卡券有效', '系统提示')
          const couponInfo = response.data.resultData.couponInfo
          this.checkCouponUsage(couponInfo, item)
        } else {
          this.couponData = {
            couponCode: '',
            giftCode: '',
            couponAmount: 0
          }
          this.$emit('couponChanged', this.couponData)
          this.$alert(response.data.resultMsg, '系统提示')
        }
      })
    },
    checkCouponUsage (couponInfo, item) {
      // console.log('couponInfo', couponInfo)
      // console.log('item', item)
      if (!couponInfo) {
        return
      }
      this.checkedApplicableItem(item)
      const couponType = couponInfo.couponType
      let couponAmount = 0
      // 兑换商品卡券
      if (couponType === '01') {
        const limitItemId = couponInfo.limitItemId
        let limitItemQty = couponInfo.limitItemQty
        if (!limitItemId) {
          return
        }
        if (!limitItemQty) {
          limitItemQty = 1
        }
        let calculateQty = 0
        let calculatePrice = 0
        for (const i in this.itemList) {
          if (this.itemList[i].itemId.toString() === limitItemId.toString()) {
            calculateQty = limitItemQty
            calculatePrice = this.itemList[i].promotionPrice && this.itemList[i].promotionPrice > 0 ? this.itemList[i].promotionPrice : this.itemList[i].itemPrice
            if (parseInt(calculateQty) > parseInt(this.itemList[i].itemQty)) {
              calculateQty = this.itemList[i].itemQty
            }
            break
          }
        }
        couponAmount = math.multiply(calculateQty, calculatePrice)
      }
      // 订单满减卡券
      if (couponType === '02') {
        // 最大满减金额
        const deductAmountLimit = couponInfo.deductAmountLimit
        if (this.applicableItemTotalAmount() >= deductAmountLimit) {
          couponAmount = couponInfo.deductAmountValue
        }
      }
      // 折扣券
      if (couponType === '03') {
        let discountRatio = 0
        if (couponInfo.discountRatio > 1) {
          discountRatio = 1
        } else {
          discountRatio = math.subtract(1, couponInfo.discountRatio)
        }
        let applicableItemList = []
        this.applicableItemList.forEach((item, index) => {
          applicableItemList.push({
            item: item,
            index: index
          })
        })
        let remainTime = item.remainTime
        if (applicableItemList.length && item.remainTime) {
          applicableItemList.sort(this.sortNumber) // 价格排序
          couponAmount = 0
          for (let i = 0; i < applicableItemList.length; i++) {
            const price = applicableItemList[i].item.promotionPrice && applicableItemList[i].item.promotionPrice > 0 ? applicableItemList[i].item.promotionPrice : applicableItemList[i].item.itemPrice
            const discountPrice = math.multiply(price, discountRatio)
            let sum = 0
            if (!remainTime) {
              break
            }
            if (parseInt(applicableItemList[i].item.itemQty) > parseInt(remainTime)) {
              sum = math.multiply(discountPrice, remainTime)
              remainTime = 0
            } else {
              sum = math.multiply(discountPrice, applicableItemList[i].item.itemQty)
              remainTime = math.subtract(remainTime, applicableItemList[i].item.itemQty)
            }
            couponAmount = math.add(couponAmount, sum)

            let obj = this.applicableItemList[applicableItemList[i].index]
            console.log('obj', obj)
            obj.reduce = sum.toFixed(2)
            this.itemList.forEach((item, index) => {
              if (item.itemId === obj.itemId) {
                this.$set(this.itemList, index, obj)
              }
            })
          }
        } else {
          couponAmount = 0
        }
        couponAmount = Number(couponAmount.toFixed(2))
      }
      // 抵扣金额
      if (couponType === '04') {
        const applicableItemTotalAmount = this.applicableItemTotalAmount()
        const discountAmount = Number(couponInfo.discountAmount)
        couponAmount = discountAmount > applicableItemTotalAmount ? applicableItemTotalAmount : discountAmount
      }
      // 叠加满减
      if (couponType === '05' && this.applicableItemTotalAmount() >= couponInfo.deductAmountLimit) {
        // 更新剩余抵扣次数
        item.remainTime = math.subtract(couponInfo.limitDiscountQty, couponInfo.usedDiscountQty)
        // 订单最大抵扣次数
        const num = parseInt(math.divide(this.applicableItemTotalAmount(), couponInfo.deductAmountLimit))
        // 最新 剩余抵扣次数
        const limit = math.subtract(couponInfo.limitDiscountQty, couponInfo.usedDiscountQty)
        if (limit > num) {
          couponAmount = math.multiply(num, couponInfo.deductAmountValue)
        } else {
          couponAmount = math.multiply(limit, couponInfo.deductAmountValue)
        }
      }

      if (couponAmount > 0) {
        this.couponData.couponCode = couponInfo.couponCode
        this.couponData.giftCode = couponInfo.giftCode
        this.couponData.couponAmount = couponAmount
        this.$emit('couponChanged', this.couponData)
      } else {
        this.$alert('该卡券不适用当前订单，请重新选择卡券', '系统提示')
        this.checkedCouponCode = ''
        this.couponData = {
          couponCode: '',
          giftCode: '',
          couponAmount: 0
        }
        this.clearReduce()
        this.$emit('couponChanged', this.couponData)
      }
    },
    removeCouponCode (action) {
      this.checkedCouponCode = ''
      this.couponData = {
        couponCode: '',
        giftCode: '',
        couponAmount: 0
      }
      if (action) {
        return
      } else {
        this.clearReduce()
      }
      this.$emit('couponChanged', this.couponData)
    },
    // 显示隐藏卡券
    moreCoupon () {
      if (this.isShow) {
        this.filterCouponList = this.couponList.slice(0, this.limitNum)
      } else {
        this.filterCouponList = this.couponList
      }
      this.isShow = !this.isShow
    },
    percentage (num) {
      return math.multiply(Number(num), 10) + '折'
    },
    // 清除商品抵扣金额
    clearReduce () {
      for (const i in this.itemList) {
        if (this.itemList[i].reduce) {
          let obj = this.itemList[i]
          obj.reduce = ''
          this.$set(this.itemList, i, obj)
        }
      }
      // console.log('xxx' + 'clearReduce')
    },
    sortNumber (a, b) {
      let aPrice = a.item.promotionPrice && a.item.promotionPrice > 0 ? a.item.promotionPrice : a.item.itemPrice
      let bPrice = b.item.promotionPrice && b.item.promotionPrice > 0 ? b.item.promotionPrice : b.item.itemPrice
      return parseFloat(bPrice) - parseFloat(aPrice)
    },
    // 检查卡券适用商品
    checkedApplicableItem (couponList) {
      // console.log('checked', couponList)
      this.applicableItemList = []
      // 三种适用类型只会有一种有值
      const abiBrandIds = couponList.limitAbiBrand ? couponList.limitAbiBrand.split(',') : []
      const categoryIds = couponList.limitCategory ? couponList.limitCategory.split(',') : []
      const itemIds = couponList.limitItem ? couponList.limitItem.split(',') : []
      // let applicableType
      // // 卡券限制适用品牌时
      // if (abiBrandIds.length) {
      //   applicableType = abiBrandIds
      // }
      // // 卡券限制适用分类时
      // if (categoryIds.length) {
      //   applicableType = categoryIds
      // }
      // // 卡券限制适用商品时
      // if (itemIds.length) {
      //   applicableType = itemIds
      // }
      for (let i = 0; i < this.itemList.length; i++) {
        if (abiBrandIds.length) {
          this.itemList[i].itemBrandList.forEach(brand => {
            if (abiBrandIds.indexOf(brand.abiBrandId) > -1) {
              this.applicableItemList.push(this.itemList[i])
            }
          })
        }
        if (categoryIds.length) {
          if (categoryIds.indexOf(this.itemList[i].categoryId) > -1) {
            this.applicableItemList.push(this.itemList[i])
          }
        }
        if (itemIds.length) {
          if (itemIds.indexOf(this.itemList[i].itemId) > -1) {
            this.applicableItemList.push(this.itemList[i])
          }
        }
      }
    },
    applicableItemTotalAmount () {
      let total = 0
      // 付全款
      this.applicableItemList.map(item => {
        const salePrice = item.promotionPrice && item.promotionPrice > 0 ? item.promotionPrice : item.itemPrice
        const rowSum = math.multiply(item.itemQty, salePrice)
        total = math.add(total, rowSum)
      })
      return parseFloat(commonUtils.formatNumber(total).toFixed(2))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../order-confirm.scss';
</style>
